export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum ModalType {
	ERROR,
	CONFIRM,
	HELP,
	PROMOTED,
	H2H_CHALLENGE,
	SECONDARY_REGISTRATION,
	ACCEPT_TERMS,
	SCORING,
	DAY_PICKER,
	PLAYER_STATS,
	TUTORIAL,
	TOMORROW_GAME,
}

export enum RankChangeState {
	UP = "up",
	DOWN = "down",
	NONE = "none",
}

export enum ContestStatus {
	Open = "open",
	Live = "live",
	Scheduled = "scheduled",
	Complete = "complete",
}

export enum RosterPlayStatus {
	Open = "open",
	Live = "live",
	Scheduled = "scheduled",
	Complete = "complete",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum Locale {
	EN_US = "en-US",
}

export enum Language {
	EN = "en",
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum PlayerStatActionEnum {
	NONE = "none",
	AT_BAT = "at_bat",
	ON_DECK = "on_deck",
	IN_HOLE = "in_hole",
	ON_BASE = "on_base",
	DUE_UP_1ST = "due_up_1st",
	DUE_UP_2ND = "due_up_2nd",
	DUE_UP_3RD = "due_up_3rd",
	ON_MOUND = "on_mound",
	REMOVED = "removed",
}

export enum RosterSelectionType {
	AUTO = "auto",
	BY_USER = "by_user",
	AUTO_SUBBED = "auto_subbed",
}

export enum GameLevel {
	SINGLE_A = "single_a",
	HIGH_A = "high_a",
	AA = "aa",
	AAA = "aaa",
	MLB_CALL_UP = "mlb_call_up",
	MLB_STARTER = "mlb_starter",
	MLB_ALL_STAR = "mlb_all_star",
	MLB_HALL_OF_FAMER = "mlb_hall_of_famer",
}

export enum GameLevelStatus {
	RemainSame = "remain_same",
	Promoted = "promoted",
	Demoted = "demoted",
}

export enum LeaderboardType {
	Daily = "daily",
	Weekly = "weekly",
}

export enum RoundStatus {
	Open = "open",
	Live = "live",
	Complete = "complete",
}

export enum GameBarStats {
	weeklyRank = "weeklyRank",
	dailyPts = "dailyPts",
	dailyRank = "dailyRank",
	weeklyPts = "weeklyPts",
	projPts = "projPts",
}

export enum HeadToHeadMode {
	Manage,
	Friends,
}

export enum ChecksumsKeys {
	contests = "contests",
	players = "players",
	squads = "squads",
	tournaments = "tournaments",
	contestPlayerStats = "contestPlayerStats",
	rounds = "rounds",
	playerStats = "playerStats",
	contestRankings = "contestRankings",
	roundRankings = "roundRankings",
}

export enum ContextualProjects {
	BEAT_THE_STREAK = "beat_the_streak",
	BY_THE_NUMBER = "by_the_number",
	SPINBALL = "spinball",
	PLAYER_OF_THE_GAME = "player_of_the_game",
}

export * from "./player";
